import React from "react";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import SmartSurveysTable from "../../../components/smart/LCF402/SurveysTable/SurveysTable";
import { ProfileCard } from "../../../components/ui-library/ProfileCard/ProfileCard";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import { useTranslation } from "react-i18next";

const ParticipantLanding = (props) => {
  const {
    match: {
      params: { participantId },
    },
    route,
    studies,
    claims,
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <SmartPageHeader
        title={studies && studies[0]?.code}
        studyId={route.study}
        subtitle=""
        roleName="Participant"
        shouldFetchParticipant={true}
        participantId={participantId}
      />
      {claims?.includes("rarejourney.canView") && (
        <ProfileCard
          title={t("appText.participant.landing.surveys.table.header")}
          showIcon={false}
        >
          <SmartSurveysTable participantId={participantId} />
        </ProfileCard>
      )}
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(ParticipantLanding);
